import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class UtilsService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getUtils() {
        return this.httpClient.get(environment.api.base + 'utils/data');
    }
}
UtilsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(i0.ɵɵinject(i1.HttpClient)); }, token: UtilsService, providedIn: "root" });
